import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import html2canvas from "html2canvas";
import axiosClient from "../../axios-client";

ChartJS.register(ArcElement, Tooltip, Legend);

const GlobalPieChart = ({ segments, subscriptions }) => {
  const [aggregatedSegments, setAggregatedSegments] = useState([]);

  useEffect(() => {
    if (segments?.segments) {
      let mergedSegments = {};

      segments.segments.forEach((segment) => {
        segment.segments.forEach((seg) => {
          if (!mergedSegments[seg.name]) {
            mergedSegments[seg.name] = {
              name: seg.name,
              subSegments: [],
            };
          }

          seg.subSegments.forEach((subSeg, i) => {
            if (!mergedSegments[seg.name].subSegments[i]) {
              mergedSegments[seg.name].subSegments[i] = {
                name: subSeg.name,
                years: subSeg.years.map((y) => ({ year: y.year, value: 0 })),
              };
            }

            subSeg.years.forEach((yearData, j) => {
              mergedSegments[seg.name].subSegments[i].years[j].value +=
                yearData.value;
            });
          });
        });
      });

      setAggregatedSegments(Object.values(mergedSegments));
    }
  }, [segments]);

  const colors = [
    "#889CEC",
    "#DD517C",
    "#B042AA",
    "#ED7845",
    "#CC4068",
    "#E96F52",
    "#7A8FE0",
    "#983D95",
    "#D94C72",
    "#D94C72",
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  const downloadChartAsPNG = (index) => {
    const canvasContainer = document.getElementById(`chartContainer-${index}`);
    if (!canvasContainer) return;
    addDownloads();
    html2canvas(canvasContainer).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `Global_Report_chart_${index}.png`;
      link.click();
    });
  };
  // const [subscriptions, setSubscriptions] = useState([]);
  const [userData, setUserData] = useState();
  const userID = localStorage.getItem("userID");
  // const fetchSubscriptions = async () => {
  //   try {
  //     const response = await axiosClient.get(
  //       `/subscriptions/getSubscriptionsByUser/${userID}`
  //     );
  //     setSubscriptions(response.data);
  //   } catch (error) {
  //     console.error("Error fetching subscriptions:", error);
  //   }
  // };
  useEffect(() => {
    const plansData = sessionStorage.getItem("plans");
    if (plansData) {
      const parsedData = JSON.parse(plansData);
      setUserData(parsedData);
    }
  }, []);
  const addDownloads = async () => {
    const subscriptionId = subscriptions[0]?._id;
    try {
      const response = await axiosClient.patch(
        `/subscriptions/update-plan/${subscriptionId}`
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="py-8">
      <div className="flex flex-wrap justify-center gap-10">
        {aggregatedSegments.map((segment, index) => {
          const subSegments = segment?.subSegments?.slice(0, -1);
          const labels = subSegments?.map((subSegment) => subSegment?.name);

          const secondYearValues = subSegments?.map((subSegment) =>
            subSegment.years[1]?.value.toFixed(2)
          );
          const lastYearValues = subSegments?.map((subSegment) =>
            subSegment.years[subSegment.years.length - 1]?.value.toFixed(2)
          );
          const secondYear = subSegments[0]?.years[1]?.year;
          const lastYear =
            subSegments[0]?.years[subSegments[0]?.years.length - 1]?.year;

          const data2025 = {
            labels,
            datasets: [
              {
                data: secondYearValues,
                backgroundColor: colors,
                hoverOffset: 4,
              },
            ],
          };

          const data2033 = {
            labels,
            datasets: [
              { data: lastYearValues, backgroundColor: colors, hoverOffset: 4 },
            ],
          };

          return (
            <div
              key={index}
              className="container mx-auto p-6 bg-white rounded-lg shadow border1 font-inter"
            >
              <div className="mb-4 flex flex-col lg:flex-row items-center justify-between font-inter">
                <h2 className="text-xl font-bold font4">
                  Global Market, {segment?.name} {secondYear} & {lastYear}
                </h2>
                {userData?.features?.graphDownloadLimit >
                  subscriptions[0]?.downloads?.downloadGraphs && (
                  <button
                    onClick={() => downloadChartAsPNG(index)}
                    className="bg-black text-white px-14 py-2 rounded-xl font-semibold hover:bg-[#21242a]"
                  >
                    Download
                  </button>
                )}
              </div>
              <div
                className="w-full flex gap-10 flex-wrap"
                id={`chartContainer-${index}`}
                style={{ justifyContent: "center", gap: "18rem" }}
              >
                {/* Pie Chart for 2025 */}
                <div className="w-1/5">
                  <h3 className="text-center font-medium font-inter text-2xl mb-4">
                    Year {secondYear}
                  </h3>
                  <Pie data={data2025} options={options} />
                  <div className="mt-4 flex flex-wrap justify-between">
                    {subSegments?.map((subSegment, i) => (
                      <div key={i} className="flex items-center gap-2 mb-2">
                        <div
                          className="w-4 h-4 rounded-full"
                          style={{ backgroundColor: colors[i] }}
                        ></div>
                        <span className="text-sm font-medium">
                          {subSegment?.name}: {secondYearValues[i]}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Pie Chart for 2033 */}
                <div className="w-1/5">
                  <h3 className="text-center font-medium font-inter text-2xl mb-4">
                    Year {lastYear}
                  </h3>
                  <Pie data={data2033} options={options} />
                  <div className="mt-4 flex flex-wrap justify-between">
                    {subSegments?.map((subSegment, i) => (
                      <div key={i} className="flex items-center gap-2 mb-2">
                        <div
                          className="w-4 h-4 rounded-full"
                          style={{ backgroundColor: colors[i] }}
                        ></div>
                        <span className="text-sm font-medium">
                          {subSegment?.name}: {lastYearValues[i]}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GlobalPieChart;
